import { render, staticRenderFns } from "./monitorRecord.vue?vue&type=template&id=4e31fb5e&scoped=true&"
import script from "./monitorRecord.vue?vue&type=script&lang=js&"
export * from "./monitorRecord.vue?vue&type=script&lang=js&"
import style0 from "./monitorRecord.vue?vue&type=style&index=0&id=4e31fb5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e31fb5e",
  null
  
)

export default component.exports